import email from "../images/email.svg";
import call from "../images/call.svg";
import linkedInLogo from "../images/linkedin.svg";
import githubLogo from "../images/github-logo-face.svg";
import location from "../images/location.svg";
import cv from "../images/curriculum.svg";

import CV from "../files/CV-Kaustubh-Padwal.pdf";

const iconStyle = { width: "2rem", height: "2rem" };

const contactDetails = [
  {
    id: 111,
    content1: (
      <a
        href="mailto:kaustubhpadwal@icloud.com"
        alt="email"
        className="contact-option-text"
      >
        kaustubhpadwal@icloud.com
      </a>
    ),
    content2: (
      <a href="tel:729402537" alt="mobile" className="contact-option-text">
        +48 729 402 537
      </a>
    ),
    title: "How to reach me?",
    icon1: (
      <img
        src={email}
        alt="email"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
    icon2: (
      <img
        src={call}
        alt="call"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
  },
  {
    id: 111,
    content1: (
      <a
        href="https://www.linkedin.com/in/kaustubh-padwal-876495179/"
        target="__blank"
        alt="email"
        className="contact-option-text"
      >
        Connect with me via LinkedIn
      </a>
    ),
    content2: (
      <a
        href="https://github.com/11kaustubhpadwal"
        target="__blank"
        alt="email"
        className="contact-option-text"
      >
        View all of my code samples on GitHub
      </a>
    ),
    title: "Want to connect with me?",
    icon1: (
      <img
        src={linkedInLogo}
        alt="linkedin-logo"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
    icon2: (
      <img
        src={githubLogo}
        alt="github-logo"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
  },
  {
    id: 111,
    content1: "Lublin, Poland",
    content2: (
      <a href={CV} alt="cv" download className="contact-option-text">
        Download my CV
      </a>
    ),
    title: "More about me?",
    icon1: (
      <img
        src={location}
        alt="location"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
    icon2: (
      <img
        src={cv}
        alt="cv"
        style={iconStyle}
        className="contact-option-icon"
      />
    ),
  },
];

export default contactDetails;
